import React from "react";
import { useAuth, ROLE_LABELS } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function Settings() {
  const { user, logout } = useAuth();
  return (
    <div className="space-y-6" data-testid="settings-page">
      <div><h1 className="font-heading text-3xl font-bold tracking-tight">Profile & Settings</h1><p className="mt-1 text-muted-foreground">Your account details.</p></div>
      <Card className="max-w-lg space-y-4 p-6">
        <div><p className="text-xs uppercase tracking-wider text-muted-foreground">Name</p><p className="font-medium">{user.name}</p></div>
        <div><p className="text-xs uppercase tracking-wider text-muted-foreground">Email</p><p className="font-medium">{user.email}</p></div>
        <div><p className="text-xs uppercase tracking-wider text-muted-foreground">Role</p><p className="font-medium">{ROLE_LABELS[user.role]}</p></div>
        <div><p className="text-xs uppercase tracking-wider text-muted-foreground">KYC Status</p>
          <p className="font-medium" data-testid="settings-kyc-status">
            {user.kyc_reverify ? "⚠ Re-verification required" : user.kyc_completed ? "✓ Completed" : "Not submitted"}
          </p>
          {user.kyc_flag && <p className="text-xs text-amber-500">{user.kyc_flag.field}: {user.kyc_flag.message}</p>}
        </div>
        <div><p className="text-xs uppercase tracking-wider text-muted-foreground">Account Status</p><p className="font-medium capitalize">{user.status || "approved"}</p></div>
        <Button variant="destructive" onClick={logout} data-testid="settings-logout">Log out</Button>
      </Card>
    </div>
  );
}
